module.exports = __webpack_public_path__ + "img/cheque4.67f80848.jpg";